
import React from 'react';
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { ContractSection } from '@/types/contract.types';

interface ContractSectionSelectorProps {
  sections: ContractSection[];
  selectedSections: string[];
  onSectionToggle: (sectionId: string) => void;
}

export function ContractSectionSelector({
  sections,
  selectedSections,
  onSectionToggle
}: ContractSectionSelectorProps) {
  return (
    <div className="space-y-4">
      {sections.map((section) => (
        <Card key={section.id} className={section.isRequired ? 'border-primary/50' : ''}>
          <CardHeader className="pb-2">
            <div className="flex items-center space-x-2">
              <Checkbox
                id={`section-${section.id}`}
                checked={selectedSections.includes(section.id) || section.isRequired}
                onCheckedChange={() => !section.isRequired && onSectionToggle(section.id)}
                disabled={section.isRequired}
              />
              <Label
                htmlFor={`section-${section.id}`}
                className="text-lg font-semibold cursor-pointer"
              >
                {section.title}
                {section.isRequired && (
                  <span className="ml-2 text-sm text-muted-foreground">(Required)</span>
                )}
              </Label>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              {section.content.slice(0, 150)}...
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
